export enum CzechSalaryType {
  /** Mzda za všechny DPP. */
  DPP = "dpp",
  /** Mzda za všechny DPČ a HPP. */
  DPC_HPP = "dpc+hpp",
}
